import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import {
  useGetStudentsByLiveClassIdQuery,
  usePresentStudentsLiveClassMutation,
} from '@school_ify/schoolify-repository/src/teacher/types';

import Modal from 'components/Modal/Modal';
import Toggle from 'components/ToogleButton/Toggle';

import './Students.scoped.scss';

const Students: React.FC<{ toggleModal; liveClassId }> = ({ toggleModal, liveClassId }) => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [studentsList, setStudentsList] = useState([]);
  const [presentStudentsLiveClassMutation] = usePresentStudentsLiveClassMutation();
  const students = useGetStudentsByLiveClassIdQuery({
    variables: {
      liveClassId,
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (students.loading) {
      return;
    }
    setStudentsList(
      students.data.live_class_attendees.map(obj => {
        return {
          ...obj,
          changed: false,
        };
      })
    );
  }, [students.loading]);

  useEffect(() => {
    if (isFirstTime) {
      setIsFirstTime(false);
      return;
    }
    setOpenModal(state => !state);
  }, [toggleModal]);

  async function save() {
    // eslint-disable-next-line no-restricted-syntax
    for (const obj1 of studentsList.filter(obj => {
      return obj.changed;
    })) {
      // eslint-disable-next-line no-await-in-loop
      await presentStudentsLiveClassMutation({
        variables: {
          id: obj1.id,
          is_present: obj1.is_present,
        },
      });
    }
    setOpenModal(state => !state);
  }

  return (
    <Modal
      open={openModal}
      onClose={() => {
        setOpenModal(state => !state);
      }}
    >
      <div className="min-width-20rem">
        <h3>{t('live_classes:List_of_students')}</h3>
        <div className={'border-b mb-2 mt-2 max-h-60-vh'}>
          {studentsList.map(obj => {
            return (
              <div
                className={`flex text justify-between mt-1 mb-1 text-bold-hover ${
                  obj.is_present ? 'text-bold' : ''
                }`}
                key={obj.id}
              >
                <div>{obj?.students?.user?.full_name}</div>

                <Toggle
                  name={`item${obj.id}`}
                  key={obj.id}
                  value={obj.id}
                  onClick={val => {
                    const index = _.findIndex(studentsList, ['id', val]);
                    studentsList[index].is_present = !studentsList[index].is_present;
                    studentsList[index].changed = true;
                    setStudentsList(studentsList);
                  }}
                  checked={obj.is_present}
                />
              </div>
            );
          })}
        </div>
        <button
          className={'btn border-none bg-primary text-white mt-2 border-radius-10px'}
          onClick={save}
        >
          {t('common:save')}
        </button>
      </div>
    </Modal>
  );
};

export default Students;
